import React from 'react';
import PropTypes from 'prop-types';
import {grey300} from "../../../../../../assets/jss/main";

import {ReactComponent as MenuIcon} from "assets/img/wms/more.svg"

PackingActionButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    customMargin: PropTypes.string
};

function PackingActionButton({onClick = () => {}, customMargin = null}) {
    return (
        <button
            onClick={onClick}
            style={{
                marginLeft: customMargin ?? '16px',
                padding: '12px 16px',
                background: grey300,
                borderRadius: '8px',
                border: 'none',
                cursor: 'pointer'
            }}
        >
            <MenuIcon />
        </button>
    );
}

export default PackingActionButton;